module.exports = __webpack_public_path__ + "img/page-header.4324521.png";